import { render } from "./rateRequest.vue?vue&type=template&id=56ba1bfd"
import script from "./rateRequest.vue?vue&type=script&lang=js"
export * from "./rateRequest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__